import Vue from 'vue'
import './plugins/vuels.js'
import moment from 'moment'
import lrz from 'lrz'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

import store from './store'
import '../theme/index.css'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import VueCookies from "vue-cookies";
import echarts from 'echarts'
import './assets/icon/iconfont.css'
// import '../element-variables.scss'


import App from './App'
import router from './router'
import './styles/reset.css'

Vue.use(VueCookies);
Vue.use(mavonEditor)
Vue.use(ElementUI);
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts

//todo 解决路由跳转报错
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js